import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import { BlockType } from '../../../types/api/ElementType';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { CommentsEditView } from '../views/CommentsEditView';
import { CommentsBlockProps } from '../CommentsBlock';
import { CommentsDefaultView } from '../views/CommentsDefaultView';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import {
  BlockInteractions,
  DISPLAY_TYPE,
  Views,
  createButtonObject,
} from '../../../components/organisms/BlockInteractions';

export function CommentsBlockInteractions({ views, activeView }: CommentsBlockProps) {
  const { t } = useSonTranslation('CommentsBlock');
  const { uuid } = useBlockContext();

  const buttons = views.edit
    ? createButtonObject(
        Views.EDIT,
        Icons.EDIT_PENCIL,
        'CommentsBlock:edit',
        DISPLAY_TYPE.COLLAPSIBLE,
        <CommentsEditView {...views.edit} />,
      )
    : {};

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={BlockType.comments}
      headline={{
        text: t('edit.heading'),
        hierarchy: 2,
        visible: true,
      }}
      activeView={activeView}
      views={views}
      buttons={buttons}
    >
      <CommentsDefaultView {...views.default} />
    </BlockInteractions>
  );
}
